import styled from 'styled-components';
// import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Typography from '../../../atoms/Typography';

export const Preview = styled.div`
  background-color: ${({ theme }) => theme.lightGray};
  border: 1px solid ${({ theme }) => theme.grey[300]};
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: inherit;
  width: 100%;
  ${({ uploading }) => uploading && `filter: opacity(25%);`}

  ${({ onClick, theme }) =>
    onClick &&
    `
  &:hover {
    cursor: pointer;
    border-color: ${theme.grey[700]};
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    // border-color: red;

  }
`}

  svg {
    margin-right: 0.5rem;
  }
  p {
    margin-right: 0.5rem;
  }
`;

export const IconContainer = styled.div`
  position: absolute;
  right: -0.5rem;
  top: -0.5rem;

  z-index: 1;
  color: ${({ theme }) => theme.grey[300]};

  svg {
    background-color: ${({ theme }) => theme.white};
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.grey[300]};
    padding: 2px;
    width: 1rem;
    height: 1rem;
  }

  ${({ onClick, theme }) =>
    onClick &&
    `
    &:hover {
    cursor: pointer;
    border-color: ${theme.grey[400]};
    }
  `}
`;

export const UploaderContainer = styled.div`
  display: flex;
  margin: 0.5rem;
  margin-top: 1rem;
  position: relative;
  width: 100%;
  height: 4rem;
  
`;

export const Label = styled(Typography)`
  && {
    margin-left: 0.5rem;
  }
`;

export const Container = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const PreviewContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Uploader = styled.div`
  background-color: white;
  border: 1px solid ${({ theme }) => theme.grey[300]};
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  text-align: center;
  font-size: 0.8rem;
  ${({ disabled, theme }) =>
    disabled
      ? `
  cursor: not-allowed;
  
  `
      : `
    &:hover {
    cursor: pointer;
    border-color: ${theme.grey[700]};
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
  
  `}
  /* &:hover {
    cursor: pointer;
    border-color: ${({ theme }) => theme.grey[700]};
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  } */
`;

export const UploadIcon = styled(CloudUploadIcon)`
  && {
    font-size: 35px;
    // color: ${({ theme }) => theme.primary};
    /* margin-bottom: 0.3rem; */
  }
`;

export const LoadingIcon = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
